import { render, staticRenderFns } from "./CongestionAnalysis.vue?vue&type=template&id=118cfae0&"
import script from "./CongestionAnalysis.vue?vue&type=script&lang=js&"
export * from "./CongestionAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports